import {
  BloodTestIcon,
  CTScanIcon,
  ECGIcon,
  MedicationsIcon,
  PregnancytestIcon,
  RATIcon,
  UltrasoundIcon,
  UrinesampleIcon,
  XRayIcon,
} from "@/assets/icons";
import { Task, TaskStatus } from "@/resources/types";
import { blue, green, orange, royalblue } from "@/theme";

const getActionIcon = (type: Task["type"]) => {
  switch (type) {
    case "Blood Test":
      return BloodTestIcon;
    case "CT Scan":
      return CTScanIcon;
    case "ECG":
      return ECGIcon;
    case "Medications":
      return MedicationsIcon;
    case "Pregnancy Test":
      return PregnancytestIcon;
    case "RAT Consult":
      return RATIcon;
    case "Ultrasound":
      return UltrasoundIcon;
    case "Urine Test":
      return UrinesampleIcon;
    case "X-Ray":
      return XRayIcon;
    default:
      throw new Error("Unknown action type");
  }
};

export const getStatusColor = (status: TaskStatus) => {
  switch (status) {
    case "requested":
      return {
        backgroundColor: orange[100],
        color: orange[900],
      };
    case "done":
      return {
        backgroundColor: green[100],
        color: green[900],
      };
    case "ready":
      return {
        backgroundColor: blue[100],
        color: blue[900],
      };
    default:
      return {
        backgroundColor: royalblue[100],
        color: royalblue[900],
      };
  }
};

export type ActionProps = {
  action: Task;
  color?: string;
};

export const ActionIcon = ({ action, color }: ActionProps) => {
  const Icon = getActionIcon(action.type);
  const resolvedColor = color ?? (action.status === "not_requested" ? "inherit" : getStatusColor(action.status).color);
  return (
    <Icon style={{ color: resolvedColor }} />
  );
};
